import { TaskTypeInstructions, TaskTypeInstructionsKind } from '../types';
import { paths } from '../routes/paths';

const GOOGLE_DOC_HOST = 'docs.google.com';
const GOOGLE_DOC_PATH_RE = /^\/document(?:\/u\/\d+)?\/d\/[^/]+/;

export function isGoogleDocUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && url.hostname === GOOGLE_DOC_HOST && GOOGLE_DOC_PATH_RE.test(url.pathname);
  } catch {
    return false;
  }
}

export function parseTaskTypeInstructionsDraft(
  kind: TaskTypeInstructionsKind,
  value: string,
): TaskTypeInstructions | { error: string } {
  const trimmed = value.trim();
  if (!trimmed) {
    return {
      error: kind === 'markdown' ? 'Paste markdown instructions.' : 'Enter a Google Doc URL.',
    };
  }
  if (kind === 'google-doc-url' && !isGoogleDocUrl(trimmed)) {
    return { error: 'Enter a valid Google Docs document URL.' };
  }
  return { kind, value: trimmed };
}

export function buildTaskTypeInstructionsViewerPath(taskTypeId: string): string {
  return paths.instructions(taskTypeId);
}

export function getTaskTypeInstructionsHref(
  taskTypeId: string,
  instructions: TaskTypeInstructions,
): string {
  if (instructions.kind === 'markdown') {
    return buildTaskTypeInstructionsViewerPath(taskTypeId);
  }
  return instructions.value;
}
